"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const runEvent_1 = require("../../../app/dist/runEvent");
const updateStep_1 = require("../../../app/dist/updateStep");
exports.toolDef = {
    name: 'loom_update_step',
    description: 'Amend the structured fields of a single plan step (description, files, blockedBy, satisfies). Surgical only — for cosmetic/citation/typo fixes, NOT substantive plan redesign (use refine/regenerate for that). title and detail are body prose — edit those with loom_patch_doc. A done step (and a done plan) is immutable history EXCEPT for a citation-only patch: passing only `satisfies` (no description/files/blockedBy) records what completed work served, e.g. citing a requirement added later via loom_amend_req. Any other field on a done step, and any edit to a cancelled step, is rejected. Use this tool to amend steps — do not edit plan files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            planId: { type: 'string', description: 'Plan id (ULID e.g. "pl_01J…" or filename stem).' },
            stepId: { type: 'string', description: 'The step\'s stable id (the `id` field in the steps frontmatter, e.g. "loom-patch-doc").' },
            description: { type: 'string', description: 'New step description (the table "Step" cell). Omit to leave unchanged.' },
            files: { type: 'array', items: { type: 'string' }, description: 'Replacement "Files touched" list. Omit to leave unchanged.' },
            blockedBy: { type: 'array', items: { type: 'string' }, description: 'Replacement blockedBy list (step ids / plan ids). Omit to leave unchanged.' },
            satisfies: { type: 'array', items: { type: 'string' }, description: 'Replacement satisfies list (requirement handles). Omit to leave unchanged.' },
        },
        required: ['planId', 'stepId'],
    },
};
async function handle(root, args) {
    const planId = args['planId'];
    const stepId = args['stepId'];
    const patch = {
        ...(args['description'] !== undefined ? { description: args['description'] } : {}),
        ...(Array.isArray(args['files']) ? { files: args['files'] } : {}),
        ...(Array.isArray(args['blockedBy']) ? { blockedBy: args['blockedBy'] } : {}),
        ...(Array.isArray(args['satisfies']) ? { satisfies: args['satisfies'] } : {}),
    };
    const loadWeaveStrict = async (r, w) => {
        const result = await (0, dist_1.loadWeave)(r, w);
        if (!result)
            throw new Error(`Weave not found: ${w}`);
        return result;
    };
    const deps = {
        loadWeave: loadWeaveStrict,
        runEvent: (weaveId, event) => (0, runEvent_1.runEvent)(weaveId, event, { loadWeave: loadWeaveStrict, saveDocs: dist_1.saveDocs, loomRoot: root }),
        loomRoot: root,
    };
    const result = await (0, updateStep_1.updateStep)({ planId, stepId, patch }, deps);
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
